<template>
  <transition name="o-transition__modal">
    <CallCenterAEDModal
      v-if="showModal"
      @close="closeModal"
      class="c-aed-adminChange"
    >
      <h2
        class="o-heading o-heading--size-2 o-heading--section o-heading--border"
        slot="header"
      >
        {{ translationsAdminModal.modalHeadline }}
      </h2>
      <div slot="body">
        <div class="o-grid o-grid--gutter-small">
          <div class="o-grid__group">
            <div class="o-grid__item o-grid__item--12">
              <h4
                class="c-aed-adminChange__text-label o-heading o-heading--size-4 o-label o-label--block"
              >
                {{ translationsAdminModal.adminToTakeOver }}
              </h4>
              <v-select
                label="name"
                v-model="mutableObject"
                :options="admins"
                :reduce="option => option.id"
                :clearable="false"
                :filterable="false"
              ></v-select>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer">
        <div class="o-grid o-grid--gutter-small">
          <div class="o-grid__group">
            <div
              class="c-aed-adminChange__footer-item o-grid__item o-grid__item--grow-0"
            >
              <button
                class="o-button"
                @click="submitAdmin"
                :disabled="
                  mutableObject.id === assignee.id || mutableObject.id === null
                "
              >
                {{ translationsAdminModal.saveNewAdmin }}
              </button>
            </div>
            <div
              class="c-aed-adminChange__footer-item o-grid__item o-grid__item--grow-0"
            >
              <button
                class="o-button o-button--transparent"
                @click="closeModal()"
              >
                {{ translationsCustom.cancel || "" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </CallCenterAEDModal>
  </transition>
</template>

<script>
import { mapGetters, mapState } from "vuex";
export default {
  data() {
    return {
      section: "assignee",
      name: "Skift ejer",
      showModal: false,
      mutableObject: {}
    };
  },
  props: {
    showAdminChange: { type: Boolean, required: true }
  },
  computed: {
    ...mapGetters("aed", ["status", "assignee"]),
    ...mapState("aeds", ["admins", "items"]),
    ...mapState("translations", {
      translationsAdminModal: "adminModal",
      translationsCustom: "custom"
    })
  },
  methods: {
    closeModal() {
      this.showModal = false;
      this.$emit("close");
    },
    submitAdmin() {
      const payload = {
        api: this.$api,
        method: "PUT",
        id: this.$store.state.aed.all.id,
        section: this.section,
        data: this.mutableObject
      };
      const { dispatch } = this.$store;
      dispatch("aed/setSection", payload);
      this.closeModal();
    }
  },
  created() {
    this.showModal = this.showAdminChange;
    this.mutableObject = JSON.parse(JSON.stringify(this.assignee));
  },
  watch: {
    showAdminChange() {
      this.showModal = this.showAdminChange;
    },
    assignee(newValue) {
      const item = this.items.find(
        item => item.id === this.$store.state.aed.all.id
      );
      this.$set(item, "assignee", newValue.name);

      this.mutableObject = JSON.parse(JSON.stringify(this.assignee));
    }
  }
};
</script>

<style lang="scss">
@import "~svg-spritemap-webpack-plugin/sprites.scss";
.c-aed-adminChange {
  .vdp-datepicker {
    width: 298px;
    &__calendar-button {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 15px;
      pointer-events: none;
      + input {
        padding-right: 40px;
      }
    }
    .o-svg-icon {
      &--calendar {
        @include sprite("date");
        width: 22px;
        height: 22px;
        display: block;
      }
    }

    input {
      border: 1px solid $s-cp-neutral-600;
      border-radius: 3px;
      height: auto;
      padding: 10px;
      &:disabled {
        border: 1px solid transparent;
        background: transparent;
      }
    }
  }

  &__text-area {
    height: 80px;
    resize: none;
    width: 100%;
  }
}
</style>
